import gql from "graphql-tag";

export default gql`
  mutation updateCreditHealthRating($friendly_entity_id: String!, $updates: [UpdateInput!]!) {
    updateCreditHealthRating(friendly_entity_id: $friendly_entity_id, updates: $updates) {
      __typename
      id
      friendly_entity_id
      health_rating
      current
      user
      created_time
      modified_time
    }
  }
`;
